import Home from "./pages/home";
import NotFound from "./pages/not-found";

const routes = [
  { key: "1", path: "/", exact: true, component: () => <Home /> },
  { key: "2", component: () => <NotFound /> },
];

export default routes;
